$(function ($) {
    $('.top_slider').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    });

    $('.slider1').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    });

    $('.slider2').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    });

    $('.slider3').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    });

    var logo = $('#header_logo');
    var menu = $('#header'),
        offset = menu.offset();
    $(window).scroll(function () {
        if ($(window).scrollTop() > offset.top) {
            menu.addClass('fixed');
            logo.addClass('scroll-fixed');
            logo.removeClass('d-none');
        } else {
            menu.removeClass('fixed');
            logo.removeClass('scroll-fixed');
            logo.addClass('d-none');
        }
    });
});

$(".openbtn1").click(function () { //ボタンがクリックされたら
    const area = document.getElementById("body");

    $(this).toggleClass('active'); //ボタン自身に activeクラスを付与し
    $("#g-nav").toggleClass('panelactive'); //ナビゲーションにpanelactiveクラスを付与

    const element = document.getElementById('header');
    const targetDOMRect = element.getBoundingClientRect();
    const targetTop = targetDOMRect.top + window.pageYOffset;
    window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
    });

    if ($(this).hasClass('active')) {
        $("#g-nav").css('display', 'block');
        area.style.overflowY = "hidden";
    } else {
        $("#g-nav").css('display', 'none');
        area.style.overflowY = "auto";
    }

});

$("#g-nav a").click(function () { //ナビゲーションのリンクがクリックされたら
    const area = document.getElementById("body");

    $(".openbtn1").removeClass('active'); //ボタンの activeクラスを除去し
    $("#g-nav").removeClass('panelactive'); //ナビゲーションのpanelactiveクラスも除去

    area.style.overflowY = "auto";
});
